module.exports = "<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <p class=\"control-label\">{{t('actionGlobalDns.dnsSearch')|e}}</p>\n    <p>{{searchDomain|e}}</p>\n  </div>\n</div>\n";
